import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Setting extends BaseApi {
  constructor() {
    super({ suffix: "Project" });
  }
  getAllSettingTolid(params) {
    return this.httpService.get("setting-sakht-all-front", { headers, params });
  }
  postSettingTolid(data) {
    return this.httpService.post("set-setting-sakht", data, { headers });
  }

  getAllSettingMali(params) {
    return this.httpService.get("setting-factor-all", { headers, params });
  }
  postSettingMali(data) {
    return this.httpService.post("set-setting-factor", data, { headers });
  }

  getAllSettingDesign(params) {
    return this.httpService.get("setting-tarahi-all", { headers, params });
  }
  postSettingDesign(data) {
    return this.httpService.post("set-setting-tarahi", data, { headers });
  }
}
const SettingService = new Setting();
export default SettingService;
